import axiosAuthorised, { DEV_OVERRIDE_HEADER } from './AxiosAuthorised';
import { FieldValues } from 'react-hook-form';

export enum SendMailSourceEnum {
	Admin = 1,
	ClientSite = 2,
	APIOld = 3,
	API = 4,
	SendsPage = 5,
	ClientSiteNew = 6,
	MobileApp = 7,
}

export type FileResponseType = {
	fileUuid: string;
	fileHash: string;
};

const uploadFilesForMerge = async (files: any) => {
	const fileData = new FormData();

	files.forEach((file: any) => {
		fileData.append('files', file);
		fileData.append('fileName', file.name);
		fileData.append('PageCount', '1');
		fileData.append('FileCategory', '4');
	});

	const resp = await axiosAuthorised.post(
		`${process.env.REACT_APP_FILES_HOST}/client/v1/files/merge-upload`,
		fileData,
		{
			...DEV_OVERRIDE_HEADER,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
		}
	);

	return resp.data;
};

const uploadFile = async (file: any) => {
	const fileData = new FormData();

	fileData.append('file', file);
	fileData.append('fileName', file.name);
	fileData.append('PageCount', '1');
	fileData.append('FileCategory', '4');

	const resp = await axiosAuthorised.post(`${process.env.REACT_APP_FILES_HOST}/client/v1/userfile`, fileData, {
		...DEV_OVERRIDE_HEADER,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});

	return resp.data;
};

const sendMail = async (props: FieldValues) => {
	let postData: any = {
		fileUuid: props.file,
		notes: props.notes ?? '',
		returnAddress: '',
		pageCount: 1,
		postageOptionId: props.postage,
		mailSourceType: SendMailSourceEnum.SendsPage,
		addressId: props.address,
		sendsPageId: props.sendsPageId,
	};

	//return Promise.reject(new Error('fail'));

	const { data } = await axiosAuthorised.post(
		`${process.env.REACT_APP_API_HOST}/client/v1/mail/send`,
		JSON.stringify(postData),
		DEV_OVERRIDE_HEADER
	);

	return data;
};

export { sendMail, uploadFilesForMerge, uploadFile };
